import type { ReactNode } from 'react';

/**
 * The document review stage.
 *
 * The subject reads the exact content they are bound by. The content hash is shown so the
 * signature can be tied to the reviewed text.
 */
export function DocumentReviewSection(props: { contentHash: string }): ReactNode {
  return (
    <div className="space-y-3">
      <p className="text-sm text-content-muted">
        Read the exact text below. Signing binds this workspace to it.
      </p>
      <div className="rounded-lg border border-border bg-surface-raised p-4 text-sm whitespace-pre-wrap text-content">
        {props.contentHash}
      </div>
      <p className="font-mono text-xs text-content-subtle">Content hash: {props.contentHash}</p>
    </div>
  );
}
